import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { FaBowlFood } from "react-icons/fa6";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoEye } from "react-icons/io5";
import { MdOutlineCancel } from "react-icons/md";
import { SiTicktick } from "react-icons/si";
import { IoMdTimer } from "react-icons/io";
import { GiCampCookingPot, GiChiliPepper, GiSandsOfTime } from "react-icons/gi";
import { backendAPIBaseURL } from "./APIURLs";
import {
  COOKINGTATUS,
  GetEggIcon,
  GetNonVegIcon,
  GetVegIcon,
  months,
  ONTABLESTATUS,
  ORDEREDSTATUS,
  READYSTATUS,
  REJECTEDSTATUS,
  subscribedPlanArr,
} from "./constant";
import { PiChefHatBold } from "react-icons/pi";

export const replaceMultipleTokensFromAPI = (
  inputString,
  replacements = false,
) => {
  let result = inputString;
  if (replacements) {
    Object.entries(replacements).forEach(([key, value]) => {
      const token = `[${key}]`;
      const regex = new RegExp(
        token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "g",
      );
      result = result.replace(regex, value);
    });
  }
  return `${backendAPIBaseURL}${result}`;
};

export const generateTextAvatarURL = (name, initials = true) => {
  const safeName = (name || "Z").trim();
  const letters = "0123456789ABCDEF";
  let color = "";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  let text = "Z";
  if (initials === true) {
    const parts = safeName.split(/\s+/).filter(Boolean);
    const firstInitial = parts?.[0]?.[0]?.toUpperCase() || "Z";
    const lastInitial =
      parts.length > 1 ? parts?.[parts.length - 1]?.[0]?.toUpperCase() : "";
    text = firstInitial + lastInitial;
  } else {
    text = safeName;
  }
  const avatarURL = `https://placehold.co/40/${color}/ffffff?text=${text}`;
  return avatarURL;
};

export const userStatusElement = (status, className) => {
  const activatedElement = (
    <span
      className={`badge-status status-active ${className}`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content="User is activated"
      data-tooltip-place="bottom"
    >
      Activated
    </span>
  );
  const deactivatedElement = (
    <span
      className={`badge-status status-deactivate ${className}`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content="User is deactivated"
      data-tooltip-place="bottom"
    >
      Deactivated
    </span>
  );
  return status ? activatedElement : deactivatedElement;
};

export const userSubscribedPlanElement = (
  userSubscribedPlan,
  className = "",
) => {
  const basicPlanElement = (
    <span
      className={`badge-plan status-basic-plan ${className}`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-navbar_tooltip"
      data-tooltip-content="Basic Plan is subscribed"
      data-tooltip-place="top"
    >
      Basic Plan
    </span>
  );
  const premiumPlanElement = (
    <span
      className={`badge-plan status-premium-plan ${className}`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-navbar_tooltip"
      data-tooltip-content="Premium Plan is subscribed"
      data-tooltip-place="top"
    >
      Premium Plan
    </span>
  );
  const proPlanElement = (
    <span
      className={`badge-plan status-pro-plan ${className}`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-navbar_tooltip"
      data-tooltip-content="Pro Plan is subscribed"
      data-tooltip-place="top"
    >
      Pro Plan
    </span>
  );
  return userSubscribedPlan === subscribedPlanArr[0]
    ? basicPlanElement
    : userSubscribedPlan === subscribedPlanArr[1]
      ? premiumPlanElement
      : proPlanElement;
};

export function formatDateWithSuffix(dateStr) {
  if (!dateStr) return { formattedDate: "", colorClass: "" };
  const [year, month, day] = dateStr.split("-");
  const dayNum = parseInt(day, 10);
  const monthIndex = parseInt(month, 10) - 1;
  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  const formattedDate = `${dayNum}${getDaySuffix(dayNum)} ${months[monthIndex]}, ${year}`;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDate = new Date(dateStr);
  endDate.setHours(0, 0, 0, 0);
  const diffTime = endDate - today;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  let colorClass = "";
  if (diffDays <= 0) {
    colorClass = "text-danger";
  } else if (diffDays <= 7) {
    colorClass = "text-warning";
  }
  return { formattedDate, colorClass };
}

export function formatDateTime(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  return `${hours.toString().padStart(2, "0")}:${minutes} ${ampm} - ${day}${getDaySuffix(day)} ${months[date.getUTCMonth()]}, ${year}`;
}

export function isPlanExpired(dateString) {
  const expiryDate = new Date(dateString);
  const currentDate = new Date();
  return currentDate < expiryDate;
}

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip
    describeChild
    {...props}
    classes={{ popper: `${className} z-index-tooltip` }}
    enterTouchDelay={0}
    leaveTouchDelay={300000}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    marginTop: "8px !important",
    padding: "8px !important",
    zIndex: "900 !important"
  },
}));

export const getVegNonVegIcon = (value) => {
  return value === "Veg" ? <GetVegIcon /> : <GetNonVegIcon />;
};
export const eggItem = (value) => value && <GetEggIcon />;

export const spicyItem = (spicy) =>
  spicy ? (
    <GiChiliPepper
      className="text-danger"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={`🔥🥵 Spiccyy`}
      data-tooltip-place="top"
    />
  ) : null;
export const chefSpecialIcon = (value) =>
  value ? (
    <PiChefHatBold
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content="Chef Special Dish"
      data-tooltip-place="top"
    />
  ) : (
    "-"
  );
export const viewMenuPageLink = (menuId, className = "text-primary") => {
  const menuPageURL = `/restaurant/${menuId}/demo/menu`;
  const viewMenuPageElement = (
    <>
      <Link
        to={menuPageURL}
        target="_blank"
        className={`${className} view-menu-link`}
        data-tooltip-id="my-tooltip"
        data-tooltip-class-name="z-index-tooltip"
        data-tooltip-content="View Menu Page"
        data-tooltip-place="top"
      >
        <MdOutlineRemoveRedEye className="view-menu-eye fs-5" />
        <IoEye className="view-menu-eye2 fs-5" />
      </Link>
    </>
  );
  return menuId ? (
    viewMenuPageElement
  ) : (
    <span
      className={`badge-status status-deactivate`}
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content="Menu is not created yet!"
      data-tooltip-place="bottom"
    >
      Not created yet!
    </span>
  );
};

export const trueFalseBadgeElement = (value, trueBadge, falseBadge) => {
  const trueBadgeElement = (
    <span
      className="badge-plan status-active"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={trueBadge || "True"}
      data-tooltip-place="top"
    >
      {trueBadge || "True"}
    </span>
  );
  const falseBadgeElement = (
    <span
      className="badge-plan status-deactivate"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={falseBadge || "False"}
      data-tooltip-place="top"
    >
      {falseBadge || "False"}
    </span>
  );
  return value ? trueBadgeElement : falseBadgeElement;
};

export const dishStatusBadgeElement = (value) => {
  const isOrderedStatus = value === ORDEREDSTATUS;
  const ischefAcceptedStatus = value === "Chef Accepted";
  const isCookingStatus = value === COOKINGTATUS;
  const isReadyStatus = value === READYSTATUS;
  const isOnTableStatus = value === ONTABLESTATUS;
  const isRejectedStatus = value === REJECTEDSTATUS;
  const orderedBadgeElement = (
    <span
      className="badge-plan status-dishItem status-ordered"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={ORDEREDSTATUS}
      data-tooltip-place="top"
    >
      Ordered
    </span>
  );
  const chefAcceptedBadgeElement = (
    <span
      className="badge-plan status-dishItem status-chefAccepted"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content="Chef Accepted"
      data-tooltip-place="top"
    >
      Chef Accepted
    </span>
  );
  const cookingBadgeElement = (
    <span
      className="badge-plan status-dishItem status-cooking"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={COOKINGTATUS}
      data-tooltip-place="top"
    >
      Cooking
    </span>
  );
  const readyBadgeElement = (
    <span
      className="badge-plan status-dishItem status-ready"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={READYSTATUS}
      data-tooltip-place="top"
    >
      Ready
    </span>
  );
  const onTableBadgeElement = (
    <span
      className="badge-plan status-dishItem status-active"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={ONTABLESTATUS}
      data-tooltip-place="top"
    >
      On Table
    </span>
  );
  const rejectedBadgeElement = (
    <span
      className="badge-plan status-dishItem status-deactivate"
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={REJECTEDSTATUS}
      data-tooltip-place="top"
    >
      Rejected
    </span>
  );
  return isOrderedStatus
    ? orderedBadgeElement
    : ischefAcceptedStatus
      ? chefAcceptedBadgeElement
      : isCookingStatus
        ? cookingBadgeElement
        : isReadyStatus
          ? readyBadgeElement
          : isOnTableStatus
            ? onTableBadgeElement
            : isRejectedStatus && rejectedBadgeElement;
};
export function getOrderStatusClass(status) {
  if (typeof status !== "string") return "";
  if (status === "Preparing..." || status === COOKINGTATUS)
    return {
      statusClass: "badge-preparing",
      statusIcon: <GiCampCookingPot className="status-icon" />,
    };
  if (status.includes(READYSTATUS))
    return {
      statusClass: "badge-ready",
      statusIcon: <SiTicktick className="status-icon mx-1" />,
    };
  if (status.includes(REJECTEDSTATUS))
    return {
      statusClass: "badge-rejected",
      statusIcon: <MdOutlineCancel className="status-icon" />,
    };
  if (status === ONTABLESTATUS || status === "Food is served")
    return {
      statusClass: "badge-on-table",
      statusIcon: <FaBowlFood className="status-icon" />,
    };
  return {
    statusClass: "badge-pending",
    statusIcon: <GiSandsOfTime className="status-icon" />,
  };
}
export function getOverallOrderStatus(items, viewedBy = "restaurant-user") {
  if (!Array.isArray(items)) return "No Items";
  if (items?.length === 0) return "No Items";
  let hasOrdered = false;
  let rejectedCount = 0;
  for (const item of items) {
    if (item.status === REJECTEDSTATUS) {
      rejectedCount++;
    }
    if (item.status === ORDEREDSTATUS) {
      hasOrdered = true;
    }
  }
  if (rejectedCount > 0 && viewedBy === "restaurant-user") {
    return `${rejectedCount} item${rejectedCount > 1 ? "s" : ""} Rejected`;
  }
  const allCooking = items.some((item) => item.status === COOKINGTATUS);
  if (allCooking) {
    return "Preparing...";
  }
  const allReady = items.every((item) => item.status === READYSTATUS);
  if (allReady) {
    return "Ready to Serve";
  }
  const allOnTable = items.every((item) => item.status === ONTABLESTATUS);
  if (allOnTable) {
    return "Food is served";
  }
  if (hasOrdered) {
    return "Pending";
  }
  return "Processing";
}

export function getOrderTimeStatus(createdAt) {
  if (!createdAt) return "";
  const createdTime = new Date(createdAt).getTime();
  const currentTime = new Date(Date.now() + 5.5 * 60 * 60 * 1000);
  let diffInMs = currentTime - createdTime;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  let orderedTimeMessage;
  if (diffInMinutes < 1) {
    orderedTimeMessage = "Just Now";
  } else if (diffInMinutes < 60) {
    orderedTimeMessage = `${diffInMinutes} min${diffInMinutes > 1 ? "s" : ""} ago`;
  } else {
    orderedTimeMessage = `${diffInHours} hr${diffInHours > 1 ? "s" : ""} ago`;
  }
  return (
    <span
      data-tooltip-id="my-tooltip"
      data-tooltip-class-name="z-index-tooltip"
      data-tooltip-content={`Ordered ${orderedTimeMessage}`}
      data-tooltip-place="top"
    >
      <IoMdTimer className="fs-5" /> {orderedTimeMessage}
    </span>
  );
}
const generatedOrderIdCodes = {};
export function generateUniqueOrderIdCode() {
  const today = new Date().toISOString().split("T")[0];
  if (!generatedOrderIdCodes[today]) {
    generatedOrderIdCodes[today] = new Set();
  }
  const PREFIX = "OID";
  const TOTAL_LENGTH = 10;
  const RANDOM_LENGTH = TOTAL_LENGTH - PREFIX.length;
  const ALPHABETS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const NUMBERS = "0123456789";
  const CHARACTERS = ALPHABETS + NUMBERS;
  let code;
  do {
    let randomPart = "";
    for (let i = 0; i < RANDOM_LENGTH; i++) {
      randomPart += CHARACTERS.charAt(
        Math.floor(Math.random() * CHARACTERS.length),
      );
    }
    code = PREFIX + randomPart;
  } while (generatedOrderIdCodes[today].has(code));
  generatedOrderIdCodes[today].add(code);
  return code;
}
export function isMoreThan5MinutesAhead(dateString) {
  const orderTime = new Date(dateString).getTime();
  const currentTime = new Date(Date.now() + 5.5 * 60 * 60 * 1000);
  const differenceInMs = currentTime - orderTime;
  return differenceInMs > 5 * 60 * 1000;
}

export const slugify = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, ""); 